import styled from "styled-components";
import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import { CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
const { carbon, blue, mint } = colorsPalettes;

const SaveBtnPopupBoxContainer = styled.div`
    padding: 0px;
    box-shadow: 0 3px 5px ${rgba(carbon[500], 0.12)};
`;

export const SaveBtnPopupWrapper = styled.div<{ width: string }>`
    width: ${({ width }) => `${width}`};
    border: 1px solid ${carbon[100]};
    border-radius: 3px;
    box-sizing: border-box;
`;

export const TopContent = styled(FlexRow)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${carbon[500]};
    padding: 16px;
    gap: 12px;
`;

export const TitleTextContainer = styled(FlexColumn)`
    text-align: left;
    width: 200px;
    gap: 8px;
`;

export const Title = styled.div`
    ${setFontVariant("subtitle2", carbon[0])};
`;

export const Subtitle = styled.div`
    ${setFontVariant("listItem3", carbon[200])};
`;

export const GroupImgContainer = styled.div`
    width: 72px;
    height: 72px;
`;

export const BtnsContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledIconContainer = styled(CenteredFlexRow)<{ isHookIcon: boolean }>`
    ${SWReactIcons} {
        svg path {
            fill: ${({ isHookIcon }) => (isHookIcon ? mint[500] : carbon[200])};
        }
    }
`;

const ActionBtn = styled(FlexRow)<{ isDisabled: boolean }>`
    height: 60px;
    cursor: pointer;
    justify-content: start;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
    ${({ isDisabled }) => setFontVariant("input2", isDisabled ? carbon[100] : carbon[500])};
    pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "unset")};

    &:hover {
        ${StyledIconContainer} {
            path {
                fill: ${blue[400]};
            }
        }
    }
`;

export const NewIndustryBtn = styled(ActionBtn)`
    border-bottom: 1px solid ${carbon[100]};
    ${SWReactIcons} {
        width: 20px;
        height: 20px;
    }

    &:hover {
        ${StyledIconContainer} {
            path {
                fill: ${({ isDisabled }) => (isDisabled ? carbon[100] : blue[400])};
            }
        }
    }
`;

const MyStyleExample = styled.div<{ width: string }>`
    width: ${({ width }) => `${width}`};
`;

export const NewSegmentBtn = styled(ActionBtn)<{ isHookIcon: boolean }>`
    ${SWReactIcons} {
        width: ${({ isHookIcon }) => (isHookIcon ? "20px" : "14px")};
        height: ${({ isHookIcon }) => (isHookIcon ? "20px" : "14px")};
    }
`;
